module.exports = __webpack_public_path__ + "static/media/covid_banner.cf4ff85c.jpg";